import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AzgivComponent } from './components/azgiv/azgiv.component';
import { DashboardMainComponent } from './components/content-dashboard/dashboard-main.component';
import { ContentJobsComponent } from './components/content-jobs/content-jobs.component';
import { JobsSummaryComponent } from './components/content-jobs/jobs-summary/jobs-summary.component';
import { JobsAddFilesComponent } from './components/content-jobs/jobs-add-files/jobs-add-files.component';
import { JobsFieldMappingComponent } from './components/content-jobs/jobs-field-mapping/jobs-field-mapping.component';
import { JobsUploadLogsComponent } from './components/content-jobs/jobs-upload-logs/jobs-upload-logs.component';
import { JobsBuildtopoLogsComponent } from './components/content-jobs/jobs-buildtopo-logs/jobs-buildtopo-logs.component';
import { JobsQcLogsComponent } from './components/content-jobs/jobs-qc-logs/jobs-qc-logs.component';
// import { ContentUserAdminComponent } from './components/content-user-admin/content-user-admin.component';
import { UserAdminDataComponent } from './components/content-user-admin/user-admin-data/user-admin-data.component';
import { ContentUserGuideComponent } from './components/content-user-guide/content-user-guide.component';
import { LoginComponent } from './components/auth/login/login.component';
import { LoginAzComponent } from './components/auth/login-az/login-az.component';

import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { AdminGuardService as AdminGuard } from './services/admin-guard.service';
import { PendingChangesGuard } from './guards/pending-changes.guard';
import { PublishLayerGuard } from './guards/publish-layer.guard';

import { GuardConfigIntegratorService as ConfigIntegratorGuard } from './services/guard-config-integrator.service';
// import { ResolverLayersService } from './services/resolver-layers.service';
import { ResolverJobsTransactionsService } from './services/resolver-jobs-transactions.service';

import { AppSettings } from './app.settings';
import { ConfigUsersComponent } from './components/content-config/config-users/config-users.component';
import { ConfigSubAgenciesComponent } from './components/content-config/config-sub-agencies/config-sub-agencies.component';
import { UserVerifyComponent } from './components/auth/user-verify/user-verify.component';
import { ResolverSelectedCustomerService } from './services/resolver-selected-customer.service';
import { ConfigIntegratorsComponent } from './components/content-config/config-integrators/config-integrators.component';
import { ConfigNagComponent } from './components/content-config/config-nag/config-nag.component';
import { ContentLayersComponent } from './components/content-layers/content-layers.component';
import { LayerComplexComponent } from './components/content-layers/layer-complex/layer-complex.component';
import { ResolverInitService } from './services/resolver-init.service';
import { ContentReportsComponent } from './components/content-reports/content-reports.component';
import { TestComponent } from './components/test/test.component';
import { ConfigAgencyProfileComponent } from './components/content-config/config-agency-profile/config-agency-profile.component';
import { ResolverGiveInitService } from './services/resolver-give-init.service';

// Get login component according to portal
export function getLoginComponent() {
	return (() => {
		switch (AppSettings.loginPortal) {
			case 'AZPortal':
				return LoginAzComponent;
			case 'LBPortal':
			default:
				return LoginComponent;
		}
	})();
}

// stateName is required in data property for each Route, which has to be unique
const appRoutes: Routes = [
	//
	{
		path: 'azgiv',
		component: AzgivComponent,
		data: { stateName: 'azgiv'},
		canActivate: [AuthGuard],
		resolve: {
			giveInitResolve: ResolverGiveInitService,
			// initResolve: ResolverInitService,
			// selectedCusId: ResolverSelectedCustomerService
		},
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full'
			},
			// Dashboards
			{
				path: 'dashboard',
				component: DashboardMainComponent,
				data: { stateName: 'dashboard'},
				resolve: { 
					// layers: ResolverLayersService, 
					transactionInfo: ResolverJobsTransactionsService }
			},
			// Layers and Data
			{
				path: 'layers',
				component: ContentLayersComponent,
				// resolve: { layers: ResolverLayersService },
				children: [
					{ path: '', redirectTo: 'live-layers', pathMatch: 'full' },
					{ path: 'live-layers', redirectTo: 'live-layers/'},
					{ 
						path: 'live-layers/:layerId',
						component: LayerComplexComponent,
						data: { content: 'live' },
						canDeactivate: [PendingChangesGuard]
					}, // these content should be consistent with ContentMenuItemKey
					{ path: 'interlayers', redirectTo: 'interlayers/'},
					{
						path: 'interlayers/:layerId',
						component: LayerComplexComponent,
						data: { content: 'interlayers' },
						canDeactivate: [PendingChangesGuard]
					},
					{ path: 'published-layers', redirectTo: 'published-layers/'},
					{
						path: 'published-layers/:layerId',
						component: LayerComplexComponent,
						data: { content: 'published' },
						canDeactivate: [PendingChangesGuard],
						canActivate: [PublishLayerGuard]
					},
					{ path: 'reports', redirectTo: 'reports/'},
					{
						path: 'reports/:layerId',
						component: ContentReportsComponent,
						data: { content: 'report' },
						// canDeactivate: [PendingChangesGuard]
					},
				]
			},
			// Jobs: upload files
			{
				path: 'jobs',
				component: ContentJobsComponent,
				data: { stateName: 'jobs' },
				// resolve: { layers: ResolverLayersService },
				children: [
					{ path: '', redirectTo: 'add-files', pathMatch: 'full'},
						// {
						// 	path: 'summary',
						// 	component: JobsSummaryComponent,
						// 	data: { stateName: 'jobssummary'},
						// 	resolve: { transactionInfo: ResolverJobsTransactionsService }
						// },
					{
						path: 'add-files',
						component: JobsAddFilesComponent,
						data: { stateName: 'jobsaddfiles'},
					}, {
						path: 'field-mapping',
						component: JobsFieldMappingComponent,
						data: { stateName: 'jobsfieldmapping'}
					}, {
						path: 'upload-logs',
						component: JobsUploadLogsComponent,
						data: { stateName: 'jobsuploadlogs'},
					},
					{
						path: 'qc-logs',
						component: JobsQcLogsComponent,
						data: { stateName: 'jobsqclogs'},
					}, {
						path: 'topo-logs',
						component: JobsBuildtopoLogsComponent,
						data: { stateName: 'JobsTopoLogsComponent'}
					}
				]
			},
					// {
					// 	path: 'user-admin',
					// 	component: ContentUserAdminComponent,
					// 	data: { stateName: 'useradmin'}
					// },
			// TODO: currently on way on ui that can go to this component
			{
				path: 'data',
				component: UserAdminDataComponent,
				data: { stateName: 'data'}
			},
			// Configs
			{
				path: 'config',
				canActivate: [AdminGuard],
				children: [
					{ path: '', redirectTo: 'users', pathMatch: 'full'},
					{ path: 'users', component: ConfigUsersComponent },
					{ path: 'agency-profile', component: ConfigAgencyProfileComponent },
					{ path: 'sub-agencies', component: ConfigSubAgenciesComponent },
					{ path: 'integrators', component: ConfigIntegratorsComponent,  canActivate: [ConfigIntegratorGuard] },
					{ path: 'nag', component: ConfigNagComponent }
				]
			},
			// User Guide
			{
				path: 'user-guide',
				component: ContentUserGuideComponent,
				data: { stateName: 'userguide'}
			}, {
				path: '123test',
				component: TestComponent
			}
		]
	},
	// Authentication
	{ path: 'auth', data: { stateName: 'auth'}, children: [
		{ path: '', redirectTo: 'login', pathMatch: 'full'},
		{
			path: 'login',
			component: AppSettings.loginPortal === 'AZPortal' ? LoginAzComponent : LoginComponent,
			data: { stateName: 'login'}
		},
		{
			path: 'verify',
			component: UserVerifyComponent
		}
	]},
	// Main state
	{ path: '', redirectTo: '/azgiv/dashboard', pathMatch: 'full', data: {stateName: 'main'}}
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			// { enableTracing: true } // Debugging purposes only !!
		)
	],
	declarations: [],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }
